import { useEffect, useRef, useState } from 'react';
import { Button } from '@mui/material';
import { TemplateType, TemplateTypeLabel } from '../../../common/EmailDetails';

interface MarinerTrainingEmailTemplateProps {
  template: TemplateType,
  handleTemplateChange: (templateType: TemplateType) => void,
}

const TEMPLATE_NAME_LIST: TemplateType[] = [
  TemplateType.TRAINING_ATO_AND_CBRD,
  TemplateType.TRAINING_LE_COMSEC_EAST,
  TemplateType.TRAINING_LE_COMSEC_WEST,
  TemplateType.TRAINING_LNG_FIRE_FIGHTING,
  TemplateType.TRAINING_MECK
];

const MarinerTrainingEmailTemplate = (props: MarinerTrainingEmailTemplateProps) => {
  const templateDropdownRef = useRef<HTMLDivElement>(null);
  const [templateDropdownOpen, setTemplateDropdownOpen] = useState<boolean>(false);

  useEffect(() => {
    const handleTemplateClick = (event: MouseEvent) => {
      if (templateDropdownRef.current && !templateDropdownRef.current.contains(event.target as Node)) {
        setTemplateDropdownOpen(false);
      }
    }

    if (templateDropdownOpen) {
      document.addEventListener("mousedown", handleTemplateClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleTemplateClick);
    }
  }, [templateDropdownOpen, setTemplateDropdownOpen])

  return (
    <>
      <Button
        key={TemplateType.TRAINING_STAR_CENTER}
        variant="outlined"
        className={
          props.template === TemplateType.TRAINING_STAR_CENTER
            ? "blue-button"
            : "grey-button"
        }
        onClick={() => props.handleTemplateChange(TemplateType.TRAINING_STAR_CENTER)}
      >
        {TemplateTypeLabel[TemplateType.TRAINING_STAR_CENTER]}
      </Button>
      <div ref={templateDropdownRef} style={{ position: "relative", display: "inline-block" }}>
        <Button
          style={{
            width: "225px"
          }}
          variant="outlined"
          className={
            TEMPLATE_NAME_LIST.includes(props.template)
              ? "blue-button"
              : "grey-button"
          }
          onClick={() => setTemplateDropdownOpen(!templateDropdownOpen)}
        >
          {TEMPLATE_NAME_LIST.includes(props.template) ? TemplateTypeLabel[props.template] : "Training Templates"} {templateDropdownOpen ? "▲" : "▼"}
        </Button>
        {templateDropdownOpen && (
          <div className="dropdown-menu">
            {TEMPLATE_NAME_LIST.map((templateName: TemplateType) => (
              <div
                key={templateName}
                className="dropdown-item"
                onClick={() => {
                  props.handleTemplateChange(templateName);
                  setTemplateDropdownOpen(false);
                }}
              >
                {TemplateTypeLabel[templateName]}
              </div>
            ))}
          </div>
        )}
      </div>
   </>
  );
}

export default MarinerTrainingEmailTemplate;
